import { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
import rightImgDemo from "images/tribyou_decorations/home_with_key.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useTranslation } from "react-i18next";

export interface SectionBecomeAnAuthorProps {
  className?: string;
  rightImg?: string;
}

const SectionBecomeAnAuthor: FC<SectionBecomeAnAuthorProps> = ({
  className = "",
  rightImg = rightImgDemo,
}) => {

  const { t, ready } = useTranslation("translation");

  if (!ready) return null;

  return (
    <div
      className={`nc-SectionBecomeAnAuthor relative flex flex-col lg:flex-row items-start  ${className}`}
      data-nc-id="SectionBecomeAnAuthor"
    >
      <div className="flex-shrink-0 mb-16 lg:mb-0 lg:mr-10 lg:w-2/5 lg:mt-[2rem]">
        <NcImage src={rightImg} className="w-20" />

        <h2 className="font-semibold text-3xl sm:text-4xl mt-6 sm:mt-11">
          {t("components.becomeHost.title")}
        </h2>
        <span className="block mt-6 text-neutral-500 dark:text-neutral-400">
          {t("components.becomeHost.description")}
        </span>
        <ButtonPrimary href={"/become-host"} className="mt-6 sm:mt-11">
          {t("components.becomeHost.actionButton")}
        </ButtonPrimary>
      </div>
      <div className="flex-grow">
      </div>
    </div>
  );
};

export default SectionBecomeAnAuthor;
